import { ThemeProvider } from "@material-tailwind/react";
import React from "react";
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import store from "./redux/store";
import "webrtc-adapter";
import("tw-elements");

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
